import { toItem } from '../mappers/item';
export function parseItems(res) {
  const result = {};
  const cursor = res.cursor || null;
  const size = res.items.length || null;
  result.ts = res.ts;
  result.data = (res.items || []).map(toItem);
  result.paging = {
    cursor,
    size
  };
  return result;
}